import Phaser from 'phaser';

// Mirrors iOS's score-popup behavior. +50 and +100 use the matching sprite
// images (bigger, brighter, signature look); other amounts fall back to a
// styled text label matching the SnackerComic look.
export function eruptScoreAt(
  scene: Phaser.Scene,
  worldX: number,
  worldY: number,
  amount: number,
): void {
  let target: Phaser.GameObjects.Image | Phaser.GameObjects.Text;
  if (amount === 100 && scene.textures.exists('plus100')) {
    target = scene.add
      .image(worldX, worldY, 'plus100')
      .setOrigin(0.5)
      .setDisplaySize(150, 80)
      .setDepth(1000);
  } else if (amount === 50 && scene.textures.exists('plus50')) {
    target = scene.add
      .image(worldX, worldY, 'plus50')
      .setOrigin(0.5)
      .setDisplaySize(110, 80)
      .setDepth(1000);
  } else {
    target = scene.add
      .text(worldX, worldY, `+${amount}`, {
        fontFamily: 'SnackerComic',
        fontSize: '48px',
        color: '#ffeb00',
        stroke: '#cc0000',
        strokeThickness: 4,
      })
      .setOrigin(0.5)
      .setDepth(1000);
  }

  // Brief pop-in, then float up while fading. iOS uses scale 1.5→0.5→1.0
  // for plus100; we approximate with a short overshoot + drift.
  target.setScale(0.4);
  scene.tweens.chain({
    targets: target,
    tweens: [
      { scale: 1.15, duration: 120, ease: 'Back.Out' },
      { scale: 1.0,  duration: 100, ease: 'Sine.InOut' },
      {
        y: worldY - 130,
        alpha: 0,
        duration: 650,
        ease: 'Cubic.Out',
        onComplete: () => target.destroy(),
      },
    ],
  });
}
